import { render, staticRenderFns } from "./ProductItemCreateEditModal.vue?vue&type=template&id=00718bb7&scoped=true&"
import script from "./ProductItemCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./ProductItemCreateEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemCreateEditModal.vue?vue&type=style&index=0&id=00718bb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00718bb7",
  null
  
)

/* custom blocks */
import block0 from "./ProductItemCreateEditModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCardActions,VCardSubtitle,VCardTitle,VContainer,VDialog,VForm,VSelect,VSwitch})
